import React, { FC } from 'react';
import { Box, Grid } from '@material-ui/core';
import { AppStores } from 'store/url-builder';

import GooglePlay from 'assets/store/google-play.svg';
import AmazonStore from 'assets/store/amazon-store.svg';
import AppStore from 'assets/store/app-store.svg';
import MicrosoftStore from 'assets/store/microsoft-store.svg';

import { AppStoreProvider } from 'enums/appStoreProviders';

export const getStoreBadge = (key: any) => {
 switch (key) {
  case AppStoreProvider.GOOGLEPLAY:
   return GooglePlay;
  case AppStoreProvider.AMAZONAPPSTORE:
   return AmazonStore;
  case AppStoreProvider.MICROSOFTSTORE:
   return MicrosoftStore;
  case AppStoreProvider.APPSTORE:
   return AppStore;
 }
};

export interface AppStoreListProps {
 appStores: AppStores[];
 onItemClick?(item: AppStores): void;
}

export const AppStoreList: FC<AppStoreListProps> = ({ appStores, onItemClick }) => {
 return (
  <Grid container spacing={1} justifyContent='center'>
   {appStores.map((store, index) => {
    const clickable = !!onItemClick && !!store.storeLink;
    return (
     <Grid item key={store.storeName+index}>
      <Box
       display='flex'
       justifyContent='center'
       style={{ cursor: clickable ? 'pointer' : 'default' }}
       onClick={() => clickable && onItemClick && onItemClick(store)}>
       <img src={getStoreBadge(store.storeName)} alt={store.storeName} height='40' width='130' style={{ objectFit: 'cover' }} />
      </Box>
     </Grid>
    );
   })}
  </Grid>
 );
};
